import { Theme, ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ThemeOptions } from '@parsys/frontend_library/lib/themes/themes.types';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ConsultationTable from './ConsultationTable';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';


export default (element, store) => {
  const root = createRoot(element);
  const theme: Theme = getTheme({ app: THEME_APP_NAME, branding: window.branding } as ThemeOptions) as Theme;
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ConsultationTable
            config={element.dataset.config}
            isCCC={element.dataset.isCcc === 'True'}
            hasMultiProjects={element.dataset.multiProjects === 'True'}
            hasMultiWorkflows={element.dataset.multiWorkflows === 'True'}
            hasMultiTenants={element.dataset.multiTenants === 'True'}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
